require('./mainmenu');
require('./bannerfix');
require('./somewall');
require('./image_carousel');
require('./custom_form');
require('./ad_banner');



//////////////////
// WEBPACK FOOTER
// ./common/js/common.js
// module id = 2
// module chunks = 0